import { PromotionPackageId, PromotionType } from '~/types/promotion'

export type PromtoionConfig = (typeof promotionsStatic)[number]
export enum PromotionKey {
    CashbackSlot = 'cashback_slot',
    CashbackSport = 'cashback_sport',
    CashbackLiveCasino = 'cashback_livecasino',
    DepositBonus = 'return_100',
}
export const promotionsStatic = [
    {
        package_id: PromotionPackageId.Deposit,
        key: PromotionKey.DepositBonus,
        title: 'user-overview-promotions-return_100-title',
        description: 'user-overview-promotions-return_100-description',
        link: '/promo/khuyen-mai-100-lan-nap-dau-tien',
        type: PromotionType.Bonus,
        overview: {
            image: '/assets/images/img/overview/promotions/khuyen-mai-nap-100-bg.webp',
            image_mb:
                '/assets/images/img/overview/promotions/khuyen-mai-nap-100-bg-mb.webp',
            thumb: '/assets/images/img/overview/promotions/khuyen-mai-nap-100-thumb.webp',
            thumbMb:
                '/assets/images/img/overview/promotions/khuyen-mai-nap-100-thumb-mb.webp',
            card: {
                title: 'user-overview-promotions-return_100-card-title',
                description:
                    'user-overview-promotions-return_100-card-description',
            },
        },
        my_promotion: {
            image: '/assets/images/img/my-promotion/khuyen-mai-nap-100-bg.webp?v=1.0.1',
            image_bm:
                '/assets/images/img/my-promotion/khuyen-mai-nap-100-bg-mb.webp?v=1.0.1',
        },
    },
    {
        package_id: PromotionPackageId.Cashback,
        key: PromotionKey.CashbackSport,
        title: 'Cuồng nhiệt Sports',
        description: 'Hoàn trả lên đến 1.6%',
        link: '/promo/hoan-tra-the-thao',
        type: PromotionType.Cashback,
        overview: {
            image: '/assets/images/img/overview/promotions/hoan-tra-sport-bg.webp',
            image_mb:
                '/assets/images/img/overview/promotions/hoan-tra-sport-bg-mb.webp',
            thumb: '/assets/images/img/overview/promotions/hoan-tra-sport-thumb.webp',
            thumbMb:
                '/assets/images/img/overview/promotions/hoan-tra-sport-thumb-mb.webp',
            card: {
                title: 'Cuồng nhiệt Sports',
                description: 'Hoàn trả lên đến 1.6%',
            },
        },
        my_promotion: {
            image: '/assets/images/img/my-promotion/hoan-tra-sport-bg.webp?v=1.0.1',
            image_bm:
                '/assets/images/img/my-promotion/hoan-tra-sport-bg-mb.webp?v=1.0.1',
        },
    },
]

export const indexPromotionsPackageId = promotionsStatic.reduce(
    (acc, promotion) => {
        acc[promotion.package_id.toString()] = promotion
        return acc
    },
    {} as Record<string, PromtoionConfig>
)
